export default __webpack_public_path__ + "static/media/ngo-gif1.cdc1933e.gif";